// extracted by mini-css-extract-plugin
export default {"mainDashboardhome":"Home_mainDashboardhome__mVlIx","mainhome":"Home_mainhome__ckC6N","righthome":"Home_righthome__VOeiF","lefthome":"Home_lefthome__n16FQ"};